var map = {
	"./avatars/avatar": 21,
	"./avatars/avatar-3": 22,
	"./avatars/avatar-3.png": 22,
	"./avatars/avatar.jpg": 21,
	"./errors-images/404-error": 23,
	"./errors-images/404-error.png": 23,
	"./errors-images/505-error": 24,
	"./errors-images/505-error.png": 24,
	"./logo-icon": 25,
	"./logo-icon.png": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;